import React from 'react';
import { NuvoImporter, RejectSubmitResult } from 'nuvo-react';
import _ from 'lodash';
import { groupBy } from 'lodash';
import '../styles.css';
import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import moment from 'moment';
import { useQuery, gql } from '@apollo/client';
import { containersQry } from '../gql/ContainersQuery';
import { qualityDataQry } from '../gql/qualityDataQry';
import { conditioningDataQry } from '../gql/conditioningDataQry';
import { useMutation, useApolloClient } from '@apollo/client';
import { UPDATE_LOADING_CONTAINER } from '../graphqlDefs/containers/mutations';
import { Link } from 'react-router-dom';
import { PAGES } from '../constants/Pages';
import { conversionRate, QUANTITY_PRECISION } from '../constants/Conversion';
import { getLoadingsImporterSetting } from './utils/loadingsFrm';
import { getLoadingsByItemImporterSetting } from './utils/loadingsFrmByItem';
import { getMessage } from '../translations';
import { FILTERED_CONTAINERS_FOLLOW_UP } from '../graphqlDefs/containersFollowup/mutations';
import { getFilteredContainerFollowUpVariables } from '../component/utils/filteredContainerFollowUpVariables';

const LoadingFrmApp = () => {
  const client = useApolloClient();
  const navigate = useNavigate();
  const [activeLoader, setActiveLoader] = useState(true);
  const licenseKey = process.env.REACT_APP_LICENSE_KEY;
  const handleGoBack = () => {
    navigate(`/${PAGES.UPLOADERSCREEN}`);
  };
  const handleNavigateWeb = () => {
    window.open(`${process.env.REACT_APP_LOADING_HAROLD_WEB_URL}`, '_blank');
  };
  const [conditioningDropdownData, setConditioningDropdownData] = useState();
  const [result, setResult] = useState('');
  // State to define for fetching quality names from database
  const [dropdownData, setDropdownData] = useState();
  const [sheetJuleNumber, setSheetJuleNumber] = useState();
  const [sheetCommdityName, setSheetCommdityName] = useState();
  const [sheetCommodityId, setSheetCommodityId] = useState();
  // Graphql query fetch qualities data
  // const { data } = useQuery(containersQry);
  const qualityData = useQuery(qualityDataQry);
  const conditioningData = useQuery(conditioningDataQry);
  const filteredContainerFollowUpVariables = getFilteredContainerFollowUpVariables();
  const { data: data, loading, error } = useQuery(FILTERED_CONTAINERS_FOLLOW_UP, {
    variables: filteredContainerFollowUpVariables,
  });

  const fetchData = () => {
    const names =
      qualityData.data && qualityData.data?.qualities
        ? qualityData.data?.qualities?.map((quality) => ({
          label: quality?.name,
          alternativeMatches: [quality?.id],
          value: quality?.id,
          type: 'string',
        }))
        : '>>';

    const conditioninNames =
      conditioningData.data && conditioningData.data?.conditionnings
        ? conditioningData.data?.conditionnings?.map((conditionV) => ({
          label: conditionV?.value,
          alternativeMatches: [conditionV?.value],
          value: conditionV?.value,
          type: 'string',
        }))
        : '>>';

    // Update quality names to dropdown state
    setConditioningDropdownData(conditioninNames);
    setDropdownData(names);
    if (names !== '' || names !== undefined) {
      setActiveLoader(false);
    }
  };
  useEffect(() => {
    if (qualityData.data) {
      fetchData();
    }
  }, [qualityData.data, conditioningData.data]);

  // Fetch user unit from URL
  const { id } = useParams();
  const [userUnit, loadType, deviationType, loadDate] = id.split('&');
  const userLoadingType = loadType.toUpperCase();
  const userDeviationType = deviationType.toUpperCase();
  let ftParsedDate = '';
  if (loadDate) {
    let parsedDate;

    // Check if the date is in ISO format
    if (moment(loadDate, moment.ISO_8601, true).isValid()) {
      parsedDate = moment(loadDate).format('DD/MM/YYYY'); // Convert ISO format to DD/MM/YYYY
    } else {
      // Assuming DD/MM/YYYY format if not ISO
      parsedDate = moment(loadDate, 'DD/MM/YYYY').format('DD/MM/YYYY');
    }

    ftParsedDate = parsedDate; // The date is now in DD/MM/YYYY format
  }

  // Conversion function from user quantity to KG,Ton,St..etc unit
  const volumeConversion = (fromUnit, toUnit, quantity) => {
    if (conversionRate[fromUnit] && conversionRate[fromUnit][toUnit]) {
      const volumeConversionRate = conversionRate[fromUnit][toUnit];
      let convertedValue = quantity * volumeConversionRate;

      // Check if precision is defined for the target unit
      const precision = QUANTITY_PRECISION[toUnit];
      if (!isNaN(precision) && Number.isInteger(precision)) {
        // Apply precision and format the number
        convertedValue = convertedValue
          .toFixed(precision)
          .toLocaleString('en-US');
      }
      return convertedValue;
    } else {
      return null; // Invalid unit conversion
    }
  };
  // Conversion function to fetch quality ids from database
  function fetchQualityId(reqQulName) {
    let retQulId = 0;
    if (reqQulName !== '' && reqQulName) {
      retQulId = reqQulName;
    }
    return retQulId;
  }

  function fetchContainerOperationQuality(qualityId, harold_no) {
    if (harold_no) {
      const container = data.filteredContainersFollowUp.find(
        (item) => item.container.harold_number === harold_no
      );
      let fData = {};
      if (container && qualityId) {
        const containerOperationQuality = container.container.qualities.find(
          (quality) => quality.operationQuality.quality.id === qualityId
        );

        const containerOperationQualityId = containerOperationQuality?.id || 0;

        fData = {
          containerOperationQualityId: containerOperationQualityId,
          buyOperationId: container.buyOperationId,
          sellOperationId: container.container.sellOperationId,
          harold_number: container.container.harold_number,
          containerId: container.container.id,
          referenceNumber: container.container.referenceNumber,
          operationQualityId: containerOperationQuality?.operationQuality?.id,
        };

        return fData;
      }
    }
    return {}; // Return an empty object if no valid data is found
  }
  function getAdditionalProperties(qualityId, harold_no) {
    const containerInfo = fetchContainerOperationQuality(qualityId, harold_no);
    if (containerInfo) {
      const { buyOperationId, sellOperationId, containerId } = containerInfo;
      return {
        buyOperationId,
        sellOperationId,
        containerId,
      };
    }
    return {};
  }
  const getDimensionUnit = (unit, isDimension = false) => {
    if (unit === 'cm' || unit === 'CM') {
      return isDimension ? 'CM3' : 'CM';
    } else if (unit === 'm' || unit === 'M') {
      return isDimension ? 'M3' : 'M';
    } else if (unit === 'mm' || unit === 'MM') {
      return isDimension ? 'MM3' : 'MM';
    }
    return isDimension ? 'CM3' : 'CM';
  };
  const devaiationValue = conditioningData.data?.otherProducts.find(
    (item) =>
      ["STERILE", "sterile", "Sterile"].includes(item.name) &&
      item.group === "Deviation"
  );


  async function saveSingleCtnLoadings(res) {
    if (!res || res.length === 0) {
      return '';
    }
    // const groupedData = _.groupBy(res, 'containerId');
    const groupedData = groupBy(res, 'containerId');

    const finalObjects = [];
    for (const containerId in groupedData) {
      const group = groupedData[containerId];
      const firstItem = group[0];

      let formatedLoadingDate = '';

      if (firstItem.dateOfLoading) {
        const parsedDate = moment(firstItem.dateOfLoading, 'DD/MM/YYYY').toDate();
        formatedLoadingDate = parsedDate.toISOString();
      }
      const commonProperties = {
        dateOfLoading: formatedLoadingDate,
        estimatedMargin: null,
        gatedInDate: null,
        grossWeight: firstItem.grossQuantityQuantity || 0,
        id: firstItem.containerId,
        isPlannedLoading: false,
        loadingComment: firstItem.loadingComment || null,
        loadingInspectionCost: null,
        loadingInspectionDate: null,
        loadingInspector: null,
        loadingType: firstItem.loadingType.toUpperCase(),
        maximumGrossWeight: firstItem.maximumGrossWeight || null,
        netWeight: firstItem.quantityQuantity || 0,
        photos: null,
        referenceNumber: firstItem.referenceNumber,
        sealedNumber: firstItem.sealedNumber || null,
        tareWeight: firstItem.tareWeight || 0,
        weightUnit: firstItem.weightUnit || 'Kg',
        finalMargin: firstItem.finalMargin || null,
        isPlannedDelivery: firstItem.isPlannedDelivery || false,
        isPlannedLoading: firstItem.isPlannedLoading || false,
        photos: firstItem.photos || null,
        qualities: {
          operationQualityId: firstItem.operationQualityId || null,
          quantity: firstItem.quantityQuantity || 0,
          volume: userUnit,
        },
        totalDeliveredTons: firstItem.quantityQuantity || 0,
      };

      const loadingsArray = group.flatMap((rItem) => {
        let updatedQuantity = 0;
        let updatedConditioningQuantity = 1;
        let itemFormatedLoadingDate = '';

        if (userLoadingType === 'ITEM' || userLoadingType === 'item') {
          updatedQuantity = rItem.quantityQuantity || 0;
        } else {
          updatedConditioningQuantity = rItem.quantityUnit;
          updatedQuantity = rItem.quantityQuantity || 0;
        }

        if (rItem.dateOfLoading) {
          const parsedDate = moment(rItem.dateOfLoading, 'DD/MM/YYYY').toDate();
          itemFormatedLoadingDate = parsedDate.toISOString();
        }

        const materialLoadingTypeProperties = {
          containerId: rItem.containerId,
          qualityId: rItem.qualityId,
          dateOfLoading: itemFormatedLoadingDate,
          quantity: {
            quantity: rItem.quantityQuantity || 0,
            volume: userUnit,
          },
          containerOperationQualityId: rItem.containerOperationQualityId,
          buyOperationId: rItem.buyOperationId,
          sellOperationId: rItem.sellOperationId,
          grossQuantity: {
            quantity: rItem.grossQuantityQuantity || 0,
            volume: userUnit,
          },
          conditionning: rItem.packages || null,
          conditionningQuantity: updatedConditioningQuantity,
          packageReference: rItem.packageReference || null,
        };

        let dimensionCalculated = '';
        let dimensionUnit = 'CM3';
        const length = parseFloat(rItem.lengthQuantity || 0);
        const height = parseFloat(rItem.heightQuantity || 0);
        const width = parseFloat(rItem.widthQuantity || 0);

        if (!isNaN(length) && !isNaN(height) && !isNaN(width)) {
          dimensionCalculated = length * height * width;
        }

        dimensionUnit = getDimensionUnit(rItem.dimensionUserUnit, true);
        let heightUnit = getDimensionUnit(rItem.heightUnit);
        let lengthUnit = getDimensionUnit(rItem.lengthUnit);
        let thicknessUnit = getDimensionUnit(rItem.thicknessUnit);
        let widthUnit = getDimensionUnit(rItem.widthUnit);

        const itemLoadingTypeProperties = userLoadingType.toUpperCase() === 'MATERIAL'
          ? {}
          : {
            dimensionMeasure: {
              quantity: dimensionCalculated || 0,
              unit: dimensionUnit || 'CM3',
            },
            heightMeasure: {
              quantity: rItem.heightQuantity || 0,
              unit: heightUnit || 'CM',
            },
            lengthMeasure: {
              quantity: rItem.lengthQuantity || 0,
              unit: lengthUnit || 'CM',
            },
            thicknessMeasure: {
              quantity: rItem.thicknessQuantity || 0,
              unit: thicknessUnit || 'CM',
            },
            widthMeasure: {
              quantity: rItem.widthQuantity || 0,
              unit: widthUnit || 'CM',
            },
            numberOfPieces: rItem.numberOfPieces || null,
          };

        const loadingEntries = [
          {
            ...materialLoadingTypeProperties,
            ...itemLoadingTypeProperties,
          },
        ];
        // Duplicate the loading row with specific changes if userDeviationType is 'STERILE'
        if (userDeviationType === 'STERILE') {
          loadingEntries.push({
            ...materialLoadingTypeProperties,
            ...itemLoadingTypeProperties,
            quantity: {
              quantity: rItem.sterileQuantity || 0,
              volume: userUnit,
            },
            grossQuantity: {
              quantity: rItem.sterileQuantity || 0,
              volume: userUnit,
            },
            deviationType: 'STERILE',
            elementId: devaiationValue && devaiationValue.id ? devaiationValue.id : 0,
          });
        }

        return loadingEntries;
      });

      const finalObject = {
        ...commonProperties,
        loadings: loadingsArray,
      };

      finalObjects.push(finalObject);
    }


    // Perform the mutation for all containers at once
    try {
      const { data } = await client.mutate({
        mutation: UPDATE_LOADING_CONTAINER,
        variables: { input: finalObjects },
      });
      return { flg: true, message: 'Success', data };
    } catch (error) {
      console.error('Mutation Error:', error); // Debugging statement
      return { flg: false, message: error.message };
    }
  }

  let importerSettings = {};
  if (userLoadingType === 'ITEM' || userLoadingType === 'item') {
    importerSettings = getLoadingsByItemImporterSetting({
      dropdownData,
      conditioningDropdownData,
    });
  } else {
    importerSettings = getLoadingsImporterSetting({
      dropdownData,
      conditioningDropdownData,
    });
  }
  const handleImportResult = async (result, errors, complete, logs) => {
    const updatedResult = result.map((item) => {
      const {
        qualityId,
        harold_number,
        quantityQuantity,
        grossQuantityQuantity,
      } = item;
      const {
        buyOperationId,
        sellOperationId,
        harold_number: resultHaroldNumber,
        containerId,
      } = getAdditionalProperties(qualityId, harold_number);

      // const quantityInTons = volumeConversion(userUnit, 'T', quantityQuantity);
      // const grossQuantityInTons = volumeConversion(
      //   userUnit,
      //   'T',
      //   grossQuantityQuantity
      // );
      const quantityInTons = quantityQuantity;
      const grossQuantityInTons = grossQuantityQuantity;

      return {
        ...item,
        buyOperationId: buyOperationId ? parseInt(buyOperationId, 10) : null,
        sellOperationId: sellOperationId ? parseInt(sellOperationId, 10) : null,
        // containerOperationQualityId: containerOperationQualityId,
        harold_number,
        containerId: containerId ? parseInt(containerId, 10) : null,
        quantityInTons: quantityInTons ? parseFloat(quantityInTons, 10) : null,
        grossQuantityInTons: grossQuantityInTons
          ? parseFloat(grossQuantityInTons, 10)
          : null,
        qualityId,
      };
    });
    if (errors.length === 0) {
      let rest = '';
      rest = await saveSingleCtnLoadings(updatedResult);
      // rest = await saveLoadings(updatedResult);
      if (rest.flg) {
        complete();
        setResult(updatedResult);
      } else {
        complete(new RejectSubmitResult('Error', rest.message));
        return false;
      }
    } else {
      complete(
        new RejectSubmitResult('Error', 'Please fill the required data.')
      );
      return false;
    }
  };

  const _ = { head: (array) => array[0] };
  const commodityHeaderVariations = ['commodity', 'Commodity name', 'Commodity'];
  const findHeaderRowIndex = (data) => {
    return data.findIndex((row) =>
      row.some((cell) => commodityHeaderVariations.some((variation) => new RegExp(variation, 'i').test(cell)))
    );
  };

  const findCommodityIndex = (headerRow) => {
    return headerRow.findIndex((header) =>
      commodityHeaderVariations.some((variation) => new RegExp(variation, 'i').test(header))
    );
  };

  const getCommodityName = (data, headerRowIndex, commodityIndex) => {
    if (headerRowIndex + 1 < data.length) {
      return data[headerRowIndex + 1][commodityIndex];
    }
    return '';
  };

  const getCommodityId = (data, headerRowIndex, commodityIndex, qualityData) => {
    try {
      if (headerRowIndex + 1 < data.length) {
        const commodityNameRaw = data[headerRowIndex + 1][commodityIndex];
        const commodityName = commodityNameRaw ? String(commodityNameRaw).trim() : '';
        const matchedQuality = qualityData.data.qualities?.find(
          (quality) => {
            const qualityName = quality.name.trim();
            return qualityName === commodityName;
          }
        );
        return matchedQuality ? matchedQuality.id : null;
      }
      return null;
    } catch (error) {
      console.error('An error occurred:', error);
      return null;
    }
  };
  const handleCommodityListing = (excelData) => {
    const { data } = _.head(excelData);
    const headerRowIndex = findHeaderRowIndex(data);
    if (headerRowIndex === -1) {
      return data; // Return the original data if no header row is found
    }
    const headerRow = data[headerRowIndex];
    const commodityIndex = findCommodityIndex(headerRow);
    if (commodityIndex !== -1) {
      const commodityName = getCommodityName(data, headerRowIndex, commodityIndex);
      const commodityId = getCommodityId(data, headerRowIndex, commodityIndex, qualityData);
      return { commodityName, commodityId };
    } else {
      return data; // If 'commodity' column is not found, return the original data
    }
  };


  return data === undefined ? (
    <div className={activeLoader === true ? 'bgl-clr loading' : 'bgl-clr loading'}>
      <div className='loaderText'>
        <p className=''>{getMessage('LOADING_TEXT')} </p>
        <span>
          <i></i>
          <i></i>
          <i></i>{' '}
        </span>
      </div>
    </div>

  ) : (
    <div className='App'>
      <div className='container-wrapper'>
        <div>
          <div className=' FlexCenter'>
            {result !== '' ? (
              <button className=' back-btn' onClick={handleNavigateWeb}>
                {getMessage('CHECKOUT_LOADINGS_ON_APP')}
              </button>
            ) : (
              <></>
            )}
            <NuvoImporter
              licenseKey={licenseKey}
              settings={importerSettings}
              onResults={(result, errors, complete, logs) =>
                handleImportResult(result, errors, complete, logs)
              }
              dataHandler={{
                headerStep: async (modifier, data) => {
                  let { commodityName, commodityId } = handleCommodityListing(data);
                  setSheetCommdityName(commodityName);
                  setSheetCommodityId(commodityId);
                  setSheetJuleNumber(data[0].sheetName);
                  // Ensure data is an array and contains at least one object with a 'data' property
                  if (!Array.isArray(data) || !data[0] || !Array.isArray(data[0].data)) {
                    return;
                  }

                  // Access the rows from the first object in the array
                  const rows = data[0].data;
                  // Iterate through the rows
                  for (let i = 0; i < rows.length; i++) {
                    const element = rows[i];
                    // Check if the current row is an array
                    if (Array.isArray(element)) {
                      // Check if the row contains the specific string
                      if (element.includes('Total No. of Packages:')) {
                        modifier.removeRow(i); // Uncomment this line to actually remove the row
                      }
                    }
                  }
                },
              }}
              onEntryInit={(row, rowIndex) => {
                const currentDate = new Date(); // Get the current date and time
                let qty = row.quantityQuantity;
                // const loadingDate = userLoadDate;
                const netWeightQty = row.quantityQuantity;
                const grossWeightQty =
                  row.grossQuantityQuantity || netWeightQty;
                const qlName = sheetCommdityName;
                const refNo = row.referenceNumber;
                const julesNo = sheetJuleNumber;
                const packageReference = row.packageReference;
                let getFormulatedKgNetQty = 0;
                let getFormulatedTonNetQty = 0;
                let getFormulatedKgGrossQty = 0;
                let getFormulatedTonGrossQty = 0;
                let getQulityID = null;
                let opeID = 0;
                let sterileQuantity = row.sterileQuantity;
                let sterileGrossQuantity = row.sterileGrossQuantity;
                let numberOfPieces = row.numberOfPieces;
                let getOperationQualityId = 0;
                if (userUnit) {
                  // For Net Qty Calculations
                  // getFormulatedKgNetQty = netWeightQty;
                  getFormulatedKgNetQty = volumeConversion(
                    userUnit,
                    'Kg',
                    netWeightQty
                  );
                  getFormulatedTonNetQty = volumeConversion(
                    userUnit,
                    'T',
                    netWeightQty
                  );
                  // getFormulatedKgGrossQty = grossWeightQty;
                  getFormulatedKgGrossQty = volumeConversion(
                    userUnit,
                    'Kg',
                    grossWeightQty
                  );
                  getFormulatedTonGrossQty = volumeConversion(
                    userUnit,
                    'T',
                    grossWeightQty
                  );
                }
                if (qlName) {
                  getQulityID = fetchQualityId(qlName);
                }
                const {
                  buyOperationId,
                  sellOperationId,
                  containerOperationQualityId,
                } = getAdditionalProperties(getQulityID, julesNo);
                if (julesNo) {
                  let containerRes = fetchContainerOperationQuality(
                    sheetCommodityId,
                    julesNo
                  );
                  if (containerRes !== undefined) {
                    opeID =
                      containerRes.containerOperationQualityId === ''
                        ? 0
                        : containerRes.containerOperationQualityId;
                    getOperationQualityId = containerRes.operationQualityId;
                  }
                }
                if (row.qualityName !== 'Total No. of Packages:') {
                  return {
                    quantityQuantity: {
                      value: getFormulatedTonNetQty,
                      info: [
                        {
                          message: '',
                          level: 'info',
                        },
                      ],
                    },

                    grossQuantityQuantity: {
                      value: getFormulatedTonGrossQty,
                      info: [
                        {
                          message: '',
                          level: 'info',
                        },
                      ],
                    },
                    sterileQuantity: {
                      value: sterileQuantity,
                      info: [
                        {
                          message: '',
                          level: 'info',
                        },
                      ],
                    },
                    sterileGrossQuantity: {
                      value: sterileGrossQuantity,
                      info: [
                        {
                          message: '',
                          level: 'info',
                        },
                      ],
                    },
                    referenceNumber: {
                      value: refNo,
                      info: [
                        {
                          message: 'Reference no',
                          level: 'info',
                        },
                      ],
                    },
                    harold_number: {
                      value: julesNo,
                      info: [
                        {
                          message: 'Jules no',
                          level: 'info',
                        },
                      ],
                    },
                    qualityName: {
                      value: sheetCommdityName,
                      info: [
                        {
                          message: 'Material',
                          level: 'info',
                        },
                      ],
                    },

                    weightUnit: {
                      value: userUnit,
                      info: [
                        {
                          message: 'User selected weight',
                          level: 'info',
                        },
                      ],
                    },
                    buyOperationId: {
                      value: buyOperationId,
                      info: [
                        {
                          message: 'Buy operation no from reference no ',
                          level: 'info',
                        },
                      ],
                    },
                    sellOperationId: {
                      value: sellOperationId,
                      info: [
                        {
                          message: 'Sell operation no from reference no ',
                          level: 'info',
                        },
                      ],
                    },
                    containerOperationQualityId: {
                      value: opeID,
                      info: [
                        {
                          message: 'Container Operation Quality Id',
                          level: 'info',
                        },
                      ],
                    },
                    loadingType: {
                      value: userLoadingType,
                      info: [
                        {
                          message: 'User selected loading type',
                          level: 'info',
                        },
                      ],
                    },
                    qualityId: {
                      value: sheetCommodityId,
                      info: [
                        {
                          message: 'From material name to material ID',
                          level: 'info',
                        },
                      ],
                    },
                    packageReference: {
                      value: packageReference,
                      info: [
                        {
                          message: 'Package Reference',
                          level: 'info',
                        },
                      ],
                    },
                    operationQualityId: {
                      value: getOperationQualityId,
                      info: [
                        {
                          message: 'Operation quality id from reference no ',
                          level: 'info',
                        },
                      ],
                    },
                    // Added this for tentative error issue need to upload only from sheet
                    dateOfLoading: {
                      value: ftParsedDate,
                      // value: '23/07/2024',  
                      info: [
                        {
                          message: 'Loading date and time.',
                          level: 'info',
                        },
                      ],
                    },
                    numberOfPieces: {
                      value: numberOfPieces,
                      info: [
                        {
                          message: 'Number of pieces',
                          level: 'info',
                        },
                      ],
                    },
                  };
                }
              }}
            >
              {getMessage('IMPORT_LOADINGS')}
            </NuvoImporter>
            {/* )} */}
            <button className=' back-btn' onClick={handleGoBack}>
              {getMessage('GO_BACK')}
            </button>
          </div>
          <div className='white-box'>
            {Object.keys(result).length !== 0 && (
              <pre>
                {typeof result === 'string'
                  ? result
                  : JSON.stringify(result, null, 2)}
              </pre>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default LoadingFrmApp;